export const emptyFocused = "CvNWE";
export const emptyOther = "LTCJJe";
export const emptyFolder = "P7YSXd";
export default {emptyFocused,emptyOther,emptyFolder};